module.exports = __webpack_public_path__ + "static/media/not_found.bf7aff14.svg";